let is_widget_open = false;
/* global u */
/**
 * [description]
 * @return {[type]} [description]
 */
export default function() {
  const wrapper = u('.js-share-widget');
  const share_button = u('.js-share-widget > button');
  const widget = u('.js-share-widget > ul');

  widget.on('click', e => e.stopPropagation());
  share_button.attr('aria-expanded', 'false');

  u(document.body).on('click', e => {
    if (is_widget_open && !e.target.classList.contains('link--widget')) {
      wrapper.removeClass('share-widget-wrapper--show');
      share_button.attr('aria-expanded', 'false');
      is_widget_open = false;
    }
  });

  share_button.on('click', function(e) {
    e.preventDefault();

    u(this.parentNode).toggleClass('share-widget-wrapper--show');

    if (is_widget_open) {
      u(this).attr('aria-expanded', 'false');
    } else {
      u(this).attr('aria-expanded', 'true');
    }

    is_widget_open = !is_widget_open;
  });
};
